import React from "react";
interface IRomanizationFormatterProps {
  inputString: string;
}
function convertSubstring(inputString: string, substring: string): string {
  // Escape special characters in the substring for regex
  const escapedSubstring = substring.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  // Create a regular expression to match all occurrences of the substring
  const regex = new RegExp(escapedSubstring, "g");

  // Replace all occurrences of the substring with {substring}
  const resultString = inputString.replace(regex, `{$&}`);

  return resultString;
}

const RomanizationFormatter = (props: IRomanizationFormatterProps) => {
  let { inputString } = props;
  inputString = inputString.replace("/", "");

  inputString = inputString.replace("\\", "");
  
  if (inputString.endsWith("un")) {
    inputString = convertSubstring(inputString, "un");
  } 
  // else {
  //   inputString = convertSubstring(inputString, "u");
  // }
  
  inputString = convertSubstring(inputString, "c");
  
  // inputString =
  //   inputString.startsWith("a") || inputString.startsWith("A")
  //     ? inputString.charAt(0) + convertSubstring(inputString.substring(1), "a")
  //     : convertSubstring(inputString, "a");
  
  console.log("input string after replace a : " + inputString);
  const renderSupTags = (text: string) => {
    const regex = /{([^{}]+)}/g;
    const parts = text.split(regex);

    return parts.map((part, index) => {
      console.log("part : " + part);
      if (index % 2 === 1) {
        return (
          <sup style={{ color: "red" }} key={index}>
            {part}
          </sup>
        );
      } else {
        if (part.startsWith("a") || part.startsWith("A")) {
          return (
            <>
              <span style={{ color: "gray" }} key={index}>
                {part.charAt(0)}
              </span>
              {part.substring(1)}
            </>
          );
        }
        return part;
      }
    });
  };

  return <span>{renderSupTags(inputString)}</span>;
};
// example ahm{a}d
export default RomanizationFormatter;
